import { JsonService } from 'src/app/services/core/json.service';
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import {SubOfficeApiResources} from './suboffice.constants';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SubofficeService {
  private baseURL;

  constructor(
    private http: HttpClient,
    private jsonService: JsonService,


  ) {
    this.baseURL = SubOfficeApiResources;
  }

  private tenantIdSubject = new BehaviorSubject<any>({});
  tenantId$ = this.tenantIdSubject.asObservable();

  updateTenantId(tenantId: string) {
    this.tenantIdSubject.next(tenantId);
  }

  create(model: any): Observable<any> {
    const endPoint = `${this.baseURL.create}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

   getSubOffices(param:any): Observable<any> {
    const endPoint = `${this.baseURL.listing}`;
    let params = new HttpParams();
    for (const key in param) {
      if (param.hasOwnProperty(key)) {
        params = params.append(key, param[key]);
      }
    }
    return this.http.get<any>(endPoint, { params }).pipe(tap(data=>(this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }


  deleteSubOffice(id:any): Observable<any> {
    const endPoint = `${this.baseURL.delete}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  changeStatusSubOffice(id:any): Observable<any> {
    const endPoint = `${this.baseURL.changeStatus}/${id}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  update(id:number, model: any): Observable<any> {
    const endPoint = `${this.baseURL.update}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
